import React from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';
import { homeFor } from '../lib/permissions';

// Page not found — shown for an unknown URL AND for a route this role may not
// open. The two look identical because a page you cannot open is, to you, a page
// that is not there: 404 is the honest answer and the one a user can act on
// ("wrong link"), where "403 Forbidden" invites a support ticket about a page
// they will never be given.
//
// It does NOT keep the matrix secret, and must not be described as if it did:
// web/src/lib/permissions.json is imported into the client bundle, so every user
// already ships the whole role→feature table. No client-side gate can hide it.
// The API answers 403 on the same denial, because a real client bug has to stay
// diagnosable in the logs (spec §5).
//
// Deliberately not wrapped in Layout: this also renders for a signed-out visitor,
// and Layout needs a user to build its nav.
//
// Design: docs/superpowers/specs/2026-08-08-role-feature-permissions-design.md
export default function NotFound() {
  const role = authService.getUser()?.role || '';

  return (
    <main className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        {/* Navy, not brand teal: teal-on-gray-50 is ~2.1:1, below the 4.5:1 AA
            floor for text this size. Navy is already in the palette (the
            button below, CandidateDrawer links) and clears ~10.8:1 here. */}
        <p className="text-sm font-semibold uppercase tracking-wide text-[#1B3A6B]">404</p>
        <h1 className="mt-2 text-2xl font-bold text-gray-900">Page not found</h1>
        <p className="mt-3 text-sm text-gray-600">
          We couldn&rsquo;t find that page. It may have moved, or the link may be out of date.
        </p>
        <Link
          to={homeFor(role)}
          className="inline-block mt-8 rounded-lg bg-[#1B3A6B] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#1B3A6B]/90"
        >
          Back to SignalCue
        </Link>
      </div>
    </main>
  );
}
